import { useState, useEffect } from "react";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminPage() {
  const [authenticated, setAuthenticated] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/admin/me`, { withCredentials: true })
      .then(() => setAuthenticated(true))
      .catch(() => setAuthenticated(false))
      .finally(() => setChecking(false));
  }, [setAuthenticated, setChecking]);

  const handleLogout = async () => {
    try {
      await axios.post(`${API}/admin/logout`, {}, { withCredentials: true });
    } catch (err) {
      console.error("Logout request failed:", err);
    }
    setAuthenticated(false);
  };

  if (checking) {
    return (
      <div className="min-h-screen bg-[#152238] flex items-center justify-center">
        <div className="text-white/40 text-sm">Checking session...</div>
      </div>
    );
  }

  if (!authenticated) return <AdminLogin onLogin={() => setAuthenticated(true)} />;
  return <AdminDashboard onLogout={handleLogout} />;
}
